import { render, staticRenderFns } from "./addBundle.vue?vue&type=template&id=132048ab&scoped=true&"
import script from "./addBundle.vue?vue&type=script&lang=js&"
export * from "./addBundle.vue?vue&type=script&lang=js&"
import style0 from "./addBundle.vue?vue&type=style&index=0&id=132048ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132048ab",
  null
  
)

export default component.exports